// 工单/反馈状态枚举（接口文档 §1 状态枚举）
export const TICKET_STATUS_DIC = [
    { label: '待处理', value: 'pending' },
    { label: '处理中', value: 'processing' },
    { label: '已解决', value: 'resolved' },
    { label: '已关闭', value: 'closed' }
];

// 紧急程度枚举（接口文档 §2：普通 / 紧急）
export const TICKET_EMERGENCY_DIC = [
    { label: '普通', value: '普通' },
    { label: '紧急', value: '紧急' }
];

// 工单状态标签颜色
export const ticketStatusTag = (status) => {
    const map = {
        pending: 'info',
        processing: 'warning',
        resolved: 'success',
        closed: 'info'
    };
    return map[status] === undefined ? '' : map[status];
};

// 紧急程度标签颜色
export const ticketUrgencyTag = (urgency) => {
    const map = {
        '普通': 'info',
        '紧急': 'warning',
        '非常紧急': 'danger'
    };
    return map[urgency] === undefined ? '' : map[urgency];
};

const joinArr = (val) => {
    if (!val) return '';
    return Array.isArray(val) ? val.join('、') : val;
};

export const ticketOption = {
    align: 'center',
    menuAlign: 'center',
    headerAlign: 'center',
    border: true,
    index: true,
    indexLabel: '序号',
    selection: false,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: 120,
    labelWidth: 110,
    searchMenuSpan: 6,
    column: [
        {
            label: '关键字',
            prop: 'keyword',
            search: true,
            searchSpan: 12,
            searchPlaceholder: '称呼/电话/问题详情',
            hide: true,
            overHidden: true
        },
        {
            label: '客户姓名',
            prop: 'name',
            width: 120,
            overHidden: true
        },
        {
            label: '手机号',
            prop: 'phone',
            width: 140,
            overHidden: true
        },
        {
            label: '产品',
            prop: 'product',
            minWidth: 160,
            overHidden: true,
            formatter: (val) => joinArr(val.product || val)
        },
        {
            label: '问题分类',
            prop: 'category',
            minWidth: 160,
            overHidden: true,
            formatter: (val) => joinArr(val.category || val)
        },
        {
            label: '问题描述',
            prop: 'detail',
            minWidth: 200,
            overHidden: true,
            showOverflowTooltip: true
        },
        {
            label: '改进建议',
            prop: 'suggestion',
            minWidth: 160,
            overHidden: true,
            showOverflowTooltip: true
        },
        {
            label: '紧急程度',
            prop: 'urgency',
            type: 'select',
            width: 110,
            dicData: TICKET_EMERGENCY_DIC,
            overHidden: true
        },
        {
            label: '状态',
            prop: 'status',
            type: 'select',
            width: 100,
            dicData: TICKET_STATUS_DIC,
            search: true,
            searchSpan: 6,
            overHidden: true
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 160,
            overHidden: true,
            formatter: (val) => {
                const t = val.createTime || val;
                return t ? formatTime(t) : '';
            }
        }
    ]
};

// 时间戳格式化（毫秒）
export const formatTime = (time) => {
    if (!time) return '';
    const d = new Date(time);
    if (isNaN(d.getTime())) return time;
    const pad = (n) => (n < 10 ? '0' + n : '' + n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

// 详情展示用：分类/产品数组转字符串
export const joinArrayField = joinArr;
